import React from "react";
import './HeroSection.css';
import heroImage from "../assets/hero3.png";
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t, i18n } = useTranslation();

  return (
    <main className="hero-section" id="hero">
      <div className="text-content">
        <h1 className="fade-in-up">
          {i18n.language === 'fr'
            ? <span dangerouslySetInnerHTML={{
                __html: t('hero_description')
                  .replace("le Ministère de l'Emploi tunisien", '<span class="accent-color">le Ministère de l\'Emploi tunisien</span>')
                  .replace('Allemagne', '<span class="accent-color">Allemagne</span>')
              }} />
            : i18n.language === 'de'
            ? <span dangerouslySetInnerHTML={{
                __html: t('hero_description')
                  .replace('tunesischen Ministerium für Arbeit', '<span class="accent-color">tunesischen Ministerium für Arbeit</span>')
                  .replace('Deutschland', '<span class="accent-color">Deutschland</span>')
              }} />
            : t('hero_description')
          }
        </h1>
        <p className="fade-in-up">
          {t('hero_description2')}
        </p>
        <div className="fade-in-up">
          <button className="apply-btn" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
            {t('apply_now')}
          </button>
        </div>
      </div>
      <div className="image-section fade-in">
        <img src={heroImage} alt="Nursing Career" loading="eager" decoding="async" />
      </div>
    </main>
  );
};

export default HeroSection;
